import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, Clock, UtensilsCrossed, FolderTree, Mail, Bell, Images, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Panel, STATUS } from "@/components/admin/AdminUI";

const CARDS = [
  ["reservations_pending", "Bekleyen Rezervasyon", Clock, "/admin/rezervasyonlar"],
  ["reservations_today", "Bugünkü Rezervasyon", CalendarCheck, "/admin/rezervasyonlar"],
  ["reservations_total", "Toplam Rezervasyon", CalendarCheck, "/admin/rezervasyonlar"],
  ["waiter_calls_open", "Açık Garson Çağrısı", Bell, "/admin/mesajlar"],
  ["messages_unread", "Okunmamış Mesaj", Mail, "/admin/mesajlar"],
  ["menu_items", "Menü Ürünü", UtensilsCrossed, "/admin/menu"],
  ["categories", "Kategori", FolderTree, "/admin/kategoriler"],
  ["gallery", "Galeri Görseli", Images, "/admin/galeri"],
];

export default function Dashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/admin/stats").then(({ data }) => setS(data));
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Genel Bakış" desc="Restoranınızın dijital durumu bir bakışta." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {CARDS.map(([k, label, Icon, to], i) => (
          <Link key={k} to={to} data-testid={`admin-dashboard-stats-card-${k}`} className={`rounded-lg border p-5 transition-transform duration-300 hover:-translate-y-1 ${i === 0 ? "bg-[#140D0B] text-[#FDFBF7] border-[#140D0B]" : "bg-white border-[#E5DCD0]"}`}>
            <Icon size={18} className={i === 0 ? "text-[#D4AF37]" : "text-[#9E7B27]"} />
            <p className="mt-4 font-display text-3xl">{s ? s[k] : "–"}</p>
            <p className={`mt-1 text-xs ${i === 0 ? "text-[#CBBBAE]" : "text-[#6B5E56]"}`}>{label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-8 grid lg:grid-cols-3 gap-6">
        <Panel className="lg:col-span-2 p-6">
          <div className="flex items-center justify-between">
            <h2 className="font-serif-ym text-2xl font-semibold">Son Rezervasyonlar</h2>
            <Link to="/admin/rezervasyonlar" className="text-sm text-[#9E7B27] inline-flex items-center gap-1" data-testid="dashboard-all-reservations-link">Tümü <ArrowRight size={14} /></Link>
          </div>
          <div className="mt-4 divide-y divide-[#E5DCD0]">
            {!s?.recent_reservations?.length && <p className="py-6 text-sm text-[#6B5E56]">Henüz rezervasyon yok.</p>}
            {s?.recent_reservations?.map((r) => (
              <div key={r.id} className="py-3 flex items-center justify-between gap-3 text-sm" data-testid={`dashboard-reservation-${r.id}`}>
                <div>
                  <p className="font-semibold">{r.name} <span className="font-normal text-[#6B5E56]">· {r.guests} kişi</span></p>
                  <p className="text-xs text-[#6B5E56]">{r.date} · {r.time} · {r.phone}</p>
                </div>
                <span className={`rounded-full px-2.5 py-1 text-xs ${STATUS[r.status]?.[1]}`}>{STATUS[r.status]?.[0]}</span>
              </div>
            ))}
          </div>
        </Panel>
        <Panel className="p-6 bg-[#F3EDE2]">
          <h2 className="font-serif-ym text-2xl font-semibold">Hızlı İşlemler</h2>
          <div className="mt-4 space-y-2">
            {[["/admin/menu", "Yeni ürün ekle"], ["/admin/qr-menu", "Masa QR kodlarını yazdır"], ["/admin/ayarlar", "Duyuru bandını güncelle"], ["/admin/galeri", "Galeriye fotoğraf yükle"], ["/admin/yasal-metinler", "KVKK metnini düzenle"]].map(([to, l]) => (
              <Link key={to} to={to} className="flex items-center justify-between rounded-md bg-white border border-[#E5DCD0] px-4 py-3 text-sm hover:border-[#D4AF37]" data-testid={`dashboard-quick-${to.split("/").pop()}`}>
                {l} <ArrowRight size={14} className="text-[#9E7B27]" />
              </Link>
            ))}
          </div>
        </Panel>
      </div>
    </div>
  );
}
